import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject, InjectionToken, Component, inject, Pipe, Directive, Input } from '@angular/core';
import { ObjectUtils, IconSvgService, ConfigurationService as ConfigurationService$1, PasswordService, URLUtils, User, PermissionService, TenantCrossDomainParamsService, PreferencesService, URLChangeService, UserPreferencesService, LocalStorageUtils, CoreUtils, DateTimeFormattingService, FeatureToggleService, LicenseService, UserDetailsService, CookieUtils, UserTokenService, UserService, ScreenUtils, SubscribeService, DateUtils, HttpUtils as HttpUtils$1 } from '@niceltd/cxone-client-platform-services';
import { from, Observable, of, forkJoin, throwError, timer } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { tap, catchError, filter, map, mergeMap, retryWhen } from 'rxjs/operators';
import * as i1$1 from '@niceltd/cxone-components/toastr';
import * as i2 from '@niceltd/cxone-components/translation';
import { TranslationPipe as TranslationPipe$1 } from '@niceltd/cxone-components/translation';
import moment from 'moment';
import { ActivationStart, ActivationEnd, Router } from '@angular/router';
import { OverlayContainer } from '@angular/cdk/overlay';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$2 from '@angular/cdk/platform';
import * as i1$3 from 'angular-i18next';
import { I18NextModule } from 'angular-i18next';
class CoreServicesModule {
  /** @nocollapse */static {
    this.ɵfac = function CoreServicesModule_Factory(t) {
      return new (t || CoreServicesModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CoreServicesModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoreServicesModule, [{
    type: NgModule,
    args: [{
      declarations: [],
      imports: [],
      providers: []
    }]
  }], null, null);
})();
const requiredKeys$1 = ['translationKey', 'appContext', 'apiServerBaseUrl'];
const AppInitializerFactory = (localizationInitializer, config, initService, options) => {
  const doneMesssage = '%cThis concludes your app initialization.  Thank you and come again!';
  const doneStyling = 'font-size:1rem; color: yellow';
  const allOptions = {
    ...{
      useCookies: false,
      cxoneSuiteDefaults: true,
      disableNotifications: false,
      userPreferenceAppContext: '',
      configurationURL: '',
      preloadSpritesToDOM: false
    },
    ...options
  };
  return () => {
    return new Promise((resolve, reject) => {
      // Populate configuration data
      const configDataObs = allOptions.configData ? config.initFromConfigData(from(allOptions.configData)) : config.initFromHttpRequest(options.configurationURL, allOptions);
      //subscribe to config data
      configDataObs.subscribe(async configData => {
        const hasAllKeys = ObjectUtils.hasAllKeys(requiredKeys$1, configData);
        if (hasAllKeys) {
          try {
            let initResult = true;
            if (initService) {
              initResult = await initService.init(allOptions);
            }
            if (!initResult) {
              reject();
              return;
            }
            await localizationInitializer.load(allOptions);
            if (!allOptions.preloadSpritesDisabled) {
              let cachedIconsSpriteDataUrls;
              if (IconSvgService.instance.setAllIconsSprite && allOptions && allOptions.mfeTools && allOptions.mfeTools.DataStoreService && allOptions.mfeTools.DataStoreService.getData) {
                cachedIconsSpriteDataUrls = allOptions.mfeTools.DataStoreService.getData('iconsSpriteDataUrls');
                if (cachedIconsSpriteDataUrls) {
                  IconSvgService.instance.setAllIconsSprite(cachedIconsSpriteDataUrls);
                }
              }
              if (!cachedIconsSpriteDataUrls) {
                const iconsSpriteDataUrls = await IconSvgService.instance.loadAllIconsSprite(allOptions.preloadSprites, allOptions.preloadSpritesToDOM, allOptions.useXhrForSvgLoad);
                if (allOptions.appType === 'container' && allOptions && allOptions.mfeTools && allOptions.mfeTools.DataStoreService && allOptions.mfeTools.DataStoreService.setData) {
                  allOptions.mfeTools.DataStoreService.setData('iconsSpriteDataUrls', iconsSpriteDataUrls);
                }
              }
            }
            console.debug(doneMesssage, doneStyling);
            resolve();
          } catch {
            reject();
          }
        } else {
          console.error('configuration.json is missing a required key', requiredKeys$1);
          reject();
        }
      });
    });
  };
};
class ConfigurationService {
  static {
    this.apiServerBaseUrl = '';
  }
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  initFromHttpRequest(configURL, options) {
    return new Observable(subscriber => {
      let fallbackConfigUrl = 'assets/conf/configuration.json';
      if (options && options.appType === 'child' && options.mfeTools) {
        fallbackConfigUrl = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.CURRENT_MFE_APP_CONTEXT) + '/' + fallbackConfigUrl;
      }
      configURL = configURL || fallbackConfigUrl;
      console.debug('Loading configuration from', configURL);
      this.httpClient.get(configURL).subscribe(data => {
        console.debug('Loaded configuration data', data);
        this.setConfigurationData(data);
        subscriber.next(data);
        subscriber.complete();
      }, error => subscriber.error(error));
    });
  }
  initFromConfigData(configData) {
    return new Observable(subscriber => {
      configData.subscribe(data => {
        console.debug('Loaded configuration data', data);
        this.setConfigurationData(data);
        subscriber.next(data);
        subscriber.complete();
      }, error => subscriber.error(error));
    });
  }
  setConfigurationData(data) {
    ConfigurationService$1.instance.setConfiguration(data);
    ConfigurationService.apiServerBaseUrl = ConfigurationService$1.instance.get(ConfigurationService$1.COMMON_KEYS.ApiServerBaseUrl);
  }
  all() {
    return ConfigurationService$1.instance.all();
  }
  get(key) {
    return ConfigurationService$1.instance.get(key);
  }
  set(key, value) {
    ConfigurationService$1.instance.set(key, value);
  }
  reset() {
    ConfigurationService$1.instance.reset();
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ConfigurationService_Factory(t) {
      return new (t || ConfigurationService)(i0.ɵɵinject(HttpClient));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConfigurationService,
      factory: ConfigurationService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurationService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: i1.HttpClient,
    decorators: [{
      type: Inject,
      args: [HttpClient]
    }]
  }], null);
})();
const APP_CONFIG = new InjectionToken('');
const LocalizationInitializerFactory = initializer => {
  return () => initializer.load();
};
class DynamicLocaleId extends String {
  constructor(i18next) {
    super('');
    this.i18next = i18next;
  }
  toString() {
    return this.i18next.language;
  }
}
class LocalizationInitializer {
  constructor(i18next, http, configService) {
    this.i18next = i18next;
    this.http = http;
    this.configService = configService;
    this.platformUrlRoot = '/platform-cxone-translations';
    this.languageMapUrl = '';
    this.defaultLanguage = 'en-US';
    this.additionalTranslations = [];
    this.dataStoreKey = 'localization-data-';
    this.appType = '';
    this.languageMapUrl = `${configService.get('apiServerBaseUrl')}${this.platformUrlRoot}/languagesMap.json`;
  }
  httpGetWithCache(url, options) {
    if (this.dataStoreGet) {
      const response = this.dataStoreGet(this.dataStoreKey + url);
      if (response) {
        return new Observable(observer => {
          observer.next(response);
          observer.complete();
        });
      }
    }
    return this.http.get(url, options).pipe(tap({
      next: response => {
        if (this.appType === 'container' && this.dataStoreSet) {
          this.dataStoreSet(this.dataStoreKey + url, response);
        }
      }
    }));
  }
  detectLanguage() {
    const currentLanguage = navigator.language.toLowerCase();
    return new Promise(resolve => {
      try {
        this.httpGetWithCache(this.languageMapUrl, {
          responseType: 'json'
        }).subscribe(response => {
          if (response.localesMap[currentLanguage]) {
            console.debug(`Language detector - Found ${currentLanguage}. Mapped to ${response.localesMap[currentLanguage]}.`);
            resolve(response.localesMap[currentLanguage]);
          } else {
            console.debug(`Language detector - Could not find language ${currentLanguage} in map file defaulting \
                        to ${this.defaultLanguage}.`);
            resolve(this.defaultLanguage);
          }
        }, () => {
          resolve(this.defaultLanguage);
        });
      } catch (error) {
        console.error('Failed to load lanuage map', error);
        resolve(this.defaultLanguage);
      }
    });
  }
  filestoLoad(lang, defaultLang, baseUrl, languageMetaDataUrl) {
    const filesToLoad = [];
    const configService = this.configService;
    return new Promise(resolveLangFiles => {
      this.httpGetWithCache(languageMetaDataUrl, {
        responseType: 'json'
      }).subscribe({
        next: metadata => {
          console.debug(`Language metadata ${lang} found with url ${languageMetaDataUrl}`, metadata);
          let appLangFile = `${baseUrl}/assets/strings/strings_en_US.json`;
          if (!defaultLang) {
            // Was the translation key found in the languageMetadata
            if (metadata[configService.get('translationKey')]) {
              appLangFile = `${baseUrl}${metadata[configService.get('translationKey')].split('.')[0]}.json`;
            } else {
              // Since there was no translationKey we can't pull the file out of the metadata
              appLangFile = null;
            }
          }
          if (!configService.get('useAngularJSTranslations')) {
            if (appLangFile) {
              filesToLoad.push({
                lang,
                file: appLangFile
              });
            }
          } else {
            console.log('Not loading application strings since you elected to use the AngularJS translations');
          }
          if (metadata.cxoneComponents) {
            if (!Array.isArray(metadata.cxoneComponents)) {
              metadata.cxoneComponents = [metadata.cxoneComponents];
            }
            metadata.cxoneComponents.forEach(file => {
              let componentLangFile = `${baseUrl}/assets/strings/components/${file}`;
              if (!defaultLang) {
                componentLangFile = `${baseUrl}${file}`;
              }
              filesToLoad.push({
                lang,
                file: componentLangFile
              });
            });
          } else {
            console.error('cxoneComponents is missing from metadata', metadata);
          }
          if (!defaultLang && this.additionalTranslations) {
            this.additionalTranslations.forEach(translationKey => {
              const additionalLangFile = metadata[translationKey];
              if (additionalLangFile) {
                filesToLoad.push({
                  lang,
                  file: `${baseUrl}${additionalLangFile}`
                });
              }
            });
          } else {
            console.debug('additional translation strings are missing');
          }
          resolveLangFiles(filesToLoad);
        },
        error: err => {
          console.log(`Language metadata not found for ${languageMetaDataUrl}`, err);
          resolveLangFiles([]);
        }
      });
    });
  }
  loadTranslationFiles(namespace, lang) {
    console.debug('loadTranslationFiles', 'lang', lang, 'defaultLang', this.defaultLanguage);
    return new Promise(resolve => {
      const defaultLanguage = this.defaultLanguage;
      const httpRequests = [];
      const platformUrlRoot = this.platformUrlRoot;
      const defaultLangBaseUrl = this.configService.get('languageMetaDataPath') || this.configService.get('appContext');
      const langBaseUrl = `${this.configService.get('apiServerBaseUrl')}${platformUrlRoot}/${lang}/`;
      let englishLangFilePromise;
      const localLangFilePromise = new Promise(resolveLangFiles => {
        this.filestoLoad(defaultLanguage, true, defaultLangBaseUrl, `${defaultLangBaseUrl}/assets/languageMetaData.json`).then(resolve1 => {
          resolveLangFiles(resolve1);
        });
      });
      if (defaultLanguage !== lang) {
        englishLangFilePromise = new Promise(resolveLangFiles => {
          this.filestoLoad(lang, false, `${this.configService.get('apiServerBaseUrl')}${platformUrlRoot}/en-US/`, `${this.configService.get('apiServerBaseUrl')}${platformUrlRoot}/en-US/languageMetaData.json`).then(resolve1 => {
            resolveLangFiles(resolve1);
          });
        });
      }
      const currentLangFilePromise = new Promise(resolveLangFiles => {
        this.filestoLoad(lang, false, langBaseUrl, `${langBaseUrl}languageMetaData.json`).then(resolve1 => {
          resolveLangFiles(resolve1);
        });
      });
      Promise.all([localLangFilePromise, englishLangFilePromise, currentLangFilePromise]).then(loadFiles => {
        const allFilesToLoad = [];
        loadFiles.forEach(item => {
          if (item) {
            allFilesToLoad.push(...item);
          }
        });
        console.debug('Loading translation files', allFilesToLoad);
        allFilesToLoad.forEach(fileToLoad => {
          httpRequests.push(this.httpGetWithCache(fileToLoad.file).pipe(catchError(error => of(error))));
        });
        forkJoin(httpRequests).subscribe(results => {
          results.forEach((item, index) => {
            console.debug('Loading', allFilesToLoad[index], item instanceof HttpErrorResponse ? 'not successful' : 'successful', item);
            if (!(item instanceof HttpErrorResponse)) {
              const resourceBundle = this.i18next.languages.find(element => element.toLowerCase() === allFilesToLoad[index].lang.toLowerCase()) || allFilesToLoad[index].lang;
              this.i18next.addResourceBundle(resourceBundle, namespace, item, true, true);
            }
          });
          resolve();
        });
        if (loadFiles.length < 1) {
          resolve();
        }
      });
    });
  }
  load(options) {
    // In previous versions, the load method could receive an array of additionalTranslationStrings.
    // Now, the load method can receive an object with all the webapp-init options. This block checks
    // if the received parameter is an array (old version) or something else (new version).
    let additionalTranslationStrings;
    if (Array.isArray(options)) {
      additionalTranslationStrings = options;
    } else if (options && options.additionalTranslationStrings) {
      additionalTranslationStrings = options.additionalTranslationStrings;
    }
    if (options && options.appType) {
      this.appType = options.appType;
    }
    if (options && options.mfeTools && options.mfeTools.DataStoreService) {
      if (typeof options.mfeTools.DataStoreService.getData === 'function') {
        this.dataStoreGet = options.mfeTools.DataStoreService.getData;
      }
      if (typeof options.mfeTools.DataStoreService.setData === 'function') {
        this.dataStoreSet = options.mfeTools.DataStoreService.setData;
      }
    }
    const languageDetector = {
      type: 'languageDetector',
      async: true,
      detect: callback => {
        this.detectLanguage().then(lang => callback(lang));
      },
      init: (_services, _detectorOptions, _i18nextOptions) => {},
      cacheUserLanguage: _lng => {}
    };
    this.languageMapUrl = `${this.configService.get('apiServerBaseUrl')}${this.platformUrlRoot}/languagesMap.json`;
    this.additionalTranslations = [];
    if (additionalTranslationStrings) {
      this.additionalTranslations = additionalTranslationStrings.map(key => key);
    }
    const promise = new Promise(resolve => {
      const defaultNSParam = 'appnamespace';
      const i18NextPromise = this.i18next.use(languageDetector).init({
        debug: true,
        fallbackLng: this.defaultLanguage,
        returnEmptyString: false,
        defaultNS: defaultNSParam,
        ns: [defaultNSParam],
        resources: {}
      });
      i18NextPromise.then(() => {
        this.loadTranslationFiles(defaultNSParam, this.i18next.language).then(() => {
          resolve();
        });
      });
    });
    return promise;
  }
  addToLanguage(lang, namespace, messages, parseMessages) {
    if (parseMessages) {
      const parsedObject = {};
      for (const key in messages) {
        if (messages.hasOwnProperty(key)) {
          ObjectUtils.parseDotNotation(key, messages[key], parsedObject);
        }
      }
      this.i18next.addResourceBundle(lang, namespace, parsedObject, true, true);
    } else {
      this.i18next.addResourceBundle(lang, namespace, messages, true, true);
    }
  }
}
class PasswordExpiringService {
  constructor(toast, translationPipe) {
    this.toast = toast;
    this.translationPipe = translationPipe;
  }
  showPasswordToastIfExpiring() {
    return new Promise(resolve => {
      PasswordService.instance.getPasswordExpirationInfo().then(result => {
        if (!URLUtils.isExcludedApp(window.location.href, ['sso', 'login', 'logout'])) {
          if (result.message) {
            const messageParams = result.param ? {
              days: result.param
            } : {};
            this.toast.showToaster('error', this.translationPipe.transform(result.message, messageParams), '', false, {});
          }
        }
        resolve();
      });
    });
  }
  /** @nocollapse */
  static {
    this.ɵfac = function PasswordExpiringService_Factory(t) {
      return new (t || PasswordExpiringService)(i0.ɵɵinject(i1$1.ToastrManager), i0.ɵɵinject(i2.TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PasswordExpiringService,
      factory: PasswordExpiringService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordExpiringService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.ToastrManager
  }, {
    type: i2.TranslationPipe
  }], null);
})();
const registerOnStart = (router, translationPipe, options, mfeRoutePrefixSlash) => {
  router.events.pipe(filter(event => event instanceof ActivationStart)).subscribe(event => {
    const data = event.snapshot.data;
    const path = event.snapshot.routeConfig ? event.snapshot.routeConfig.path : undefined;
    // child apps should ignore ActivationStart events for routes in other child apps
    if (options.appType === 'child' && !isRouteRelatedToThisChildApp(event.snapshot, mfeRoutePrefixSlash)) return;
    console.debug('Angular Router >>> ActivationStart >>> ', path ? path : '(' + options.appType + ')', mfeRoutePrefixSlash ? mfeRoutePrefixSlash : '');
    handleOnStart('Angular Router', path, data);
  });
};
const handleOnStart = (routerLabel, routeName, routeData) => {
  const permission = routeData ? routeData.permission : null;
  const requireLogin = routeData ? routeData.requireLogin : false;
  console.table([{
    name: 'toState',
    value: routeName
  }, {
    name: 'loggedIn',
    value: User.instance.loggedIn
  }, {
    name: 'requireLogin',
    value: requireLogin
  }, {
    name: 'permission',
    value: permission
  }, {
    name: 'allowAccess',
    value: permission ? PermissionService.instance.allowAccess(permission) : false
  }]);
  if (User.instance.loggedIn && requireLogin && permission && !PermissionService.instance.allowAccess(permission)) {
    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
    console.debug(routerLabel + ' >>> Navigating to insufficient Privilege Page from Cxone Angular Platform Services !!!');
    URLUtils.redirectToUrl(`${authHostUrl}/login/#/insufficientPrivileges/`);
  }
  if (!User.instance.loggedIn && requireLogin) {
    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
    URLUtils.redirectToUrl(`${authHostUrl}/login/#/`);
  }
};
const registerOnSuccess = (router, translationPipe, options, mfeRoutePrefixSlash) => {
  router.events.pipe(filter(event => event instanceof ActivationEnd)).subscribe(event => {
    const data = event.snapshot.data ? event.snapshot.data : {
      rememberLastVisitedPage: null
    };
    const path = event.snapshot.routeConfig.path;
    // set the title, unless this is a router event in a
    // container app's router for a route in a child app
    if (options.appType !== 'container' || !data || !data.remoteEntry) {
      let titleKey;
      let documentTitle;
      const translationKey = data && data.translationKey ? data.translationKey : undefined;
      if (translationKey) {
        titleKey = translationKey;
      } else if (path || path === '') {
        titleKey = path;
        if (options.appType === 'child') {
          titleKey = titleKey.replace(mfeRoutePrefixSlash, '');
        }
      }
      if (titleKey || titleKey === '') {
        documentTitle = translationPipe.transform(`metaInfo.${titleKey}.title`);
        if (options.appType !== 'child') {
          document.title = documentTitle;
        } else if (options.mfeTools) {
          options.mfeTools.PubSubService.publish('title-changed', documentTitle);
        }
      }
    }
    handleOnSuccess('Angular Router', path, data);
  });
};
const handleOnSuccess = (routerLabel, routeName, data) => {
  console.debug(routerLabel + ' >>> onSuccess >>> ', routeName);
  if (data && !data.rememberLastVisitedPage) {
    PreferencesService.instance.saveStatePreference(data, ['#/logout', '#/landingPage']);
  }
};
const registerOnUrlChange = (router, options, mfeRoutePrefixSlash) => {
  router.events.pipe(filter(event => event instanceof ActivationEnd)).subscribe(event => {
    const data = event.snapshot.data;
    if (data && Object.keys(data).length !== 0 && !data.remoteEntry) {
      const path = event.snapshot.routeConfig ? event.snapshot.routeConfig.path : undefined;
      // child apps should ignore ActivationEnd events for routes in other child apps
      if (options.appType === 'child' && !isRouteRelatedToThisChildApp(event.snapshot, mfeRoutePrefixSlash)) return;
      console.debug('Angular Router >>> onURLChange >>> ', path ? path : '(' + options.appType + ')', data, mfeRoutePrefixSlash ? mfeRoutePrefixSlash : '');
      if (data.moduleId || data.pageId) {
        URLChangeService.instance.broadcastURLChange(URLChangeService.URL_CHANGED, data);
      }
      // publish child-url-changed event through mfe pubSub service
      if (options.appType === 'child' && options.mfeTools) {
        options.mfeTools.PubSubService.publish(options.mfeTools.MFE_EVENTS.CHILD_URL_CHANGED, data);
      }
    }
  });
};
const registerOtherwise = (router, options, mfeRoutePrefixSlash) => {
  // For mfe child apps, do the following:
  if (options.appType === 'child' && options.mfeTools && mfeRoutePrefixSlash) {
    // (a) add ChildUnsavedChangesCanActivateGuard to all child app routes
    if (ChildUnsavedChangesCanActivateGuard && options.mfeActivateGuard === true) {
      if (router.config && router.config.length) {
        router.config.forEach(route => {
          if (route.canActivate) {
            route.canActivate.push(ChildUnsavedChangesCanActivateGuard);
          } else {
            route.canActivate = [ChildUnsavedChangesCanActivateGuard];
          }
        });
      }
    }
    // (b) child app routers should ignore routes for other child apps
    router.config.push({
      matcher: doesNotStartWith(mfeRoutePrefixSlash),
      component: IgnoreRouteComponent
    });
  }
  // For all apps, redirect to Login if the user navigates to a non-existent route
  const fallbackSet = router.config.find(value => {
    return value.path === '**';
  });
  if (!fallbackSet) {
    router.config.push({
      path: '**',
      component: FallbackRedirectComponent
    });
  }
};
const isRouteRelatedToThisChildApp = (eventSnapshot, mfeRoutePrefixSlash) => {
  const path = eventSnapshot.routeConfig ? eventSnapshot.routeConfig.path : undefined;
  if (path === undefined) return false;
  if (path.startsWith(mfeRoutePrefixSlash)) return true;
  const pathFromRootWithRoutePrefixSlash = eventSnapshot.pathFromRoot.find(snapshot => {
    return snapshot && snapshot.routeConfig && snapshot.routeConfig.path && snapshot.routeConfig.path.startsWith(mfeRoutePrefixSlash);
  });
  if (pathFromRootWithRoutePrefixSlash) return true;
  return false;
};
class FallbackRedirectComponent {
  constructor() {
    console.debug('Angular Router >>> Route not found');
    const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
    URLUtils.redirectToUrl(`${authHostUrl}/login/#/`);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function FallbackRedirectComponent_Factory(t) {
      return new (t || FallbackRedirectComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FallbackRedirectComponent,
      selectors: [["cxone-fallback-redirect-component"]],
      decls: 0,
      vars: 0,
      template: function FallbackRedirectComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FallbackRedirectComponent, [{
    type: Component,
    args: [{
      template: '',
      selector: 'cxone-fallback-redirect-component'
    }]
  }], () => [], null);
})();
class IgnoreRouteComponent {
  /** @nocollapse */static {
    this.ɵfac = function IgnoreRouteComponent_Factory(t) {
      return new (t || IgnoreRouteComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IgnoreRouteComponent,
      selectors: [["cxone-ignore-route-component"]],
      decls: 0,
      vars: 0,
      template: function IgnoreRouteComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IgnoreRouteComponent, [{
    type: Component,
    args: [{
      template: '',
      selector: 'cxone-ignore-route-component'
    }]
  }], null, null);
})();
const doesNotStartWith = prefix => {
  return url => {
    const fullUrl = url.map(u => u.path).join('/');
    if (!fullUrl.startsWith(prefix)) {
      return {
        consumed: url
      };
    }
    return null;
  };
};
class ChildUnsavedChangesCanActivateGuard {
  constructor() {
    this.webAppInitializerServiceOptions = inject(WebAppInitializerServiceOptions);
  }
  canActivate() {
    if (this.webAppInitializerServiceOptions.mfeTools) {
      const unsavedChangesCheck = this.webAppInitializerServiceOptions.mfeTools.DataStoreService.getData(this.webAppInitializerServiceOptions.mfeTools.MFE_DATA_STORE_KEYS.UNSAVED_CHANGES_CHECK);
      const UnsavedChangesDirector = this.webAppInitializerServiceOptions.mfeTools.DataStoreService.getData('unsavedChangesDirector');
      if (typeof unsavedChangesCheck === 'function' && unsavedChangesCheck()) {
        return UnsavedChangesDirector.instance.promise;
      } else {
        return true;
      }
    }
    return true;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ChildUnsavedChangesCanActivateGuard_Factory(t) {
      return new (t || ChildUnsavedChangesCanActivateGuard)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ChildUnsavedChangesCanActivateGuard,
      factory: ChildUnsavedChangesCanActivateGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChildUnsavedChangesCanActivateGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class MfeUnsavedChangesGuard {
  constructor() {
    this.webAppInitializerServiceOptions = inject(WebAppInitializerServiceOptions);
  }
  canDeactivate() {
    if (this.webAppInitializerServiceOptions.mfeTools) {
      const unsavedChangesCheck = this.webAppInitializerServiceOptions.mfeTools.DataStoreService.getData(this.webAppInitializerServiceOptions.mfeTools.MFE_DATA_STORE_KEYS.UNSAVED_CHANGES_CHECK);
      const UnsavedChangesDirector = this.webAppInitializerServiceOptions.mfeTools.DataStoreService.getData('unsavedChangesDirector');
      if (typeof unsavedChangesCheck === 'function' && unsavedChangesCheck()) {
        return UnsavedChangesDirector.instance.promise;
      } else {
        return true;
      }
    }
    return true;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MfeUnsavedChangesGuard_Factory(t) {
      return new (t || MfeUnsavedChangesGuard)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MfeUnsavedChangesGuard,
      factory: MfeUnsavedChangesGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MfeUnsavedChangesGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
const WebAppInitializerServiceOptions = new InjectionToken('WebAppInitializerServiceOptions');
class WebAppInitializerService {
  static {
    this.WebAppOptionsDefault = {
      useCookies: false,
      cxoneSuiteDefaults: true,
      disableNotifications: false,
      userPreferenceAppContext: '',
      appType: 'standalone',
      useApiFacadeEndpoint: false,
      disableRouterFunctionalityForLegacyApps: false
    };
  }
  constructor(httpClient, configService, injector, translationPipe) {
    this.httpClient = httpClient;
    this.configService = configService;
    this.injector = injector;
    this.translationPipe = translationPipe;
    this.CXONE_TOKEN_COOKIE = 'cxone_token_info';
    this.TOKEN_EXCHANGE_COOKIE = 'token_exchange';
    this.loggingInfoStyles = '';
    this.putToasterPreferencesInLocalStorage = () => {
      UserPreferencesService.instance.getPreference('toaster_preference', UserPreferencesService.GlobalContext).then(preference => {
        if (preference) {
          LocalStorageUtils.setItem(LocalStorageUtils.KEYS.toastrManagerTimeOut, preference);
          try {
            LocalStorageUtils.getWindowObject().localStorage.setItem('sol_config.toastrTimeOut', preference);
          } catch (e) {/* do nothing if localStorage is not available */}
        }
      });
    };
  }
  async init(options) {
    console.debug('WebAppInitializerService.init options', options);
    let mfeRoutePrefixSlash = null;
    if (options.appType !== 'child') {
      // for standalone apps and the micro-frontend container app
      if (options.useApiFacadeEndpoint && this.configService.get('apiFacadeEndpoint')) {
        if (this.configService.get('staticBaseUrl') === undefined) {
          this.configService.set('staticBaseUrl', this.configService.get('apiServerBaseUrl'));
        }
        this.configService.set('apiServerBaseUrl', this.configService.get('apiFacadeEndpoint'));
      }
      const continueOn = await this.initAuthentication(options.useCookies, options.cxoneSuiteDefaults, options.disableNotifications).catch(reason => {
        console.error('Could not initialize authentication', reason);
        throw new Error(reason);
      });
      if (!continueOn) {
        return true;
      }
      options = {
        ...WebAppInitializerService.WebAppOptionsDefault,
        ...options
      };
      const initResults = await Promise.allSettled([CoreUtils.invokePromiseWithTimeout(DateTimeFormattingService.instance.getDateTimeFormatByBrowserLocale()), CoreUtils.invokePromiseWithTimeout(FeatureToggleService.instance.loadFeatures()), CoreUtils.invokePromiseWithTimeout(PermissionService.instance.getUserPermissionList()), CoreUtils.invokePromiseWithTimeout(LicenseService.instance.loadLicenses(true)), CoreUtils.invokePromiseWithTimeout(UserDetailsService.instance.getUserDetails(true)), CoreUtils.invokePromiseWithTimeout(UserPreferencesService.instance.init(options.userPreferenceAppContext))]);
      const rejectedCalls = initResults.filter(result => result.status === 'rejected');
      rejectedCalls.forEach(rejectedCall => {
        console.error('==> Rejected init REST call: ', rejectedCall);
      });
      if (options.userPreferenceAppContext) {
        this.putToasterPreferencesInLocalStorage();
      }
      const currentAppContext = this.configService.get('appContext');
      if (currentAppContext) {
        this.configService.set('traceability_key', currentAppContext);
      }
    } else {
      // for micro-frontend child apps
      FeatureToggleService.instance.setFeatures(options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.FEATURE_TOGGLES));
      const userDetails = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.USER_DETAILS);
      User.instance.token = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.USER_TOKEN);
      UserDetailsService.instance.setUserInfo(userDetails);
      LicenseService.instance.setLicenses(options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.LICENSES));
      DateTimeFormattingService.instance.setDateTimeFormats(options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.DATE_TIME_FORMATS));
      PermissionService.instance.setPermissionsList(options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.USER_PERMISSIONS));
      const storageModeFromContainer = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.STORAGE_MODE);
      if (storageModeFromContainer) {
        LocalStorageUtils.setStorageMode(options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.STORAGE_MODE));
      }
      const parentConf = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.ROOT_CONFIGURATION);
      let childConf = this.configService.all();
      childConf = {
        ...parentConf,
        ...childConf
      };
      this.configService.setConfigurationData(childConf);
      const currentAppContext = this.configService.get('appContext');
      if (currentAppContext) {
        this.configService.set('traceability_key', currentAppContext);
      }
      // read the appContext from the mfe data store
      const mfeAppContext = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.CURRENT_MFE_APP_CONTEXT) || '';
      if (mfeAppContext && typeof mfeAppContext === 'string') {
        this.configService.set('appContext', mfeAppContext);
        this.configService.set('mfe_root_path', mfeAppContext);
      }
      await UserPreferencesService.instance.init(options.userPreferenceAppContext);
      options.mfeTools.PubSubService.subscribe(options.mfeTools.MFE_EVENTS.CONTAINER_USER_TOKEN_REFRESHED, userToken => {
        User.instance.token = userToken;
      });
      // read the route prefix from the mfe data store
      mfeRoutePrefixSlash = options.mfeTools.DataStoreService.getData(options.mfeTools.MFE_DATA_STORE_KEYS.CURRENT_MFE_ROUTE_PREFIX) || '';
      if (mfeRoutePrefixSlash) {
        mfeRoutePrefixSlash = mfeRoutePrefixSlash.replace(/\/?$/, '/'); // add a trailing slash, if one isn't already present
      }
      // notify the container app that the child app has initialized
      options.mfeTools.PubSubService.publish(options.mfeTools.MFE_EVENTS.CHILD_APP_INITIALIZED, options.mfeInitData || null);
    }
    if (options.customInitFn) {
      await options.customInitFn(this.injector).catch(reason => {
        console.error('There was an issue with your custom function.  Your mileage may vary', reason);
      });
    }
    if (!window.angular) {
      this.startRouter(options, mfeRoutePrefixSlash);
    } else {
      LocalStorageUtils.setItem('AngularUser', User.instance.user);
    }
    if (options.userPreferenceAppContext) {
      this.putToasterPreferencesInLocalStorage();
    }
    return true;
  }
  isTokenExpired(tokenExpirationTime) {
    return !(tokenExpirationTime && moment().isBefore(tokenExpirationTime));
  }
  isLocalHost() {
    return window.location.href.includes('localhost');
  }
  async initAuthentication(useCookies, cxoneSuiteDefaults, disableNotifications) {
    console.debug('initAuthentication.start', window.location.href);
    const exchangeTokenCookie = CookieUtils.getCookie(this.TOKEN_EXCHANGE_COOKIE);
    const tokenCookie = CookieUtils.getCookieAsObject(this.CXONE_TOKEN_COOKIE);
    const embeddedClient = URLUtils.hasParameter(window.location.href, 'embeddedClient');
    const embeddedClientValue = URLUtils.getQueryParameter('embeddedClient', window.location.href);
    const postMessage = URLUtils.hasParameter(window.location.href, 'postMsg');
    const auth = URLUtils.hasParameter(window.location.href, 'auth');
    if (!this.isLocalHost() && embeddedClient && embeddedClientValue && embeddedClientValue === 'true') {
      console.debug('switching to session storage mode');
      LocalStorageUtils.setStorageMode(LocalStorageUtils.SESSION_STORAGE_MODE);
    }
    const tokenExpirationTime = LocalStorageUtils.getItem(LocalStorageUtils.KEYS.expirationTime);
    const tokenNotExpired = !this.isTokenExpired(tokenExpirationTime);
    console.debug('tokenExpirationTime', tokenExpirationTime);
    console.debug('exchangeTokenCookie', exchangeTokenCookie);
    console.debug('tokenCookie', tokenCookie);
    console.debug('embeddedClient', embeddedClient, 'embeddedClientValue', embeddedClientValue);
    console.debug('postMessage', postMessage);
    console.debug('auth', auth);
    console.debug('tokenNotExpired', tokenNotExpired);
    this.initScreenLayoutService(embeddedClient);
    if (embeddedClient) {
      disableNotifications = true;
    }
    if (useCookies) {
      this.useCookiesFlow(disableNotifications);
    } else if (tokenCookie) {
      await this.tokenExchangeFlow(tokenCookie, disableNotifications);
    } else if (!this.isLocalHost() && embeddedClient && postMessage) {
      await this.embeddedFlow(disableNotifications);
    } else if (exchangeTokenCookie) {
      await this.l2NavFlow(exchangeTokenCookie, disableNotifications);
    } else if (tokenNotExpired) {
      this.tokenInStorageFlow(useCookies, disableNotifications);
    } else {
      console.debug('initAuthentication.landingPage');
      PermissionService.instance.setLastAccessedPage(['#/logout', '#/landingPage', '#/sessionFrame'], ['logout']);
      const authHostUrl = TenantCrossDomainParamsService.instance.getAuthHostForArea();
      URLUtils.redirectToUrl(`${authHostUrl}/login/`);
      return false;
    }
    console.debug('initAuthentication.end');
    return true;
  }
  useCookiesFlow(disableNotifications = false) {
    console.debug('initAuthentication.useCookieFlow');
    const isCookieExists = CookieUtils.getAccessToken();
    if (isCookieExists && UserTokenService.isTokenValid()) {
      UserService.instance.initUserFromLocalStorage(true, disableNotifications);
    }
  }
  async tokenExchangeFlow(tokenCookie, disableNotifications = false) {
    console.debug('initAuthentication.tokenExchangeFlow');
    LocalStorageUtils.setItem(LocalStorageUtils.KEYS.userToken, tokenCookie.token);
    await UserService.instance.initUserFromToken(tokenCookie, disableNotifications);
  }
  async embeddedFlow(disableNotifications = false) {
    console.debug('initAuthentication.embeddedFlow');
    await UserService.instance.initUserFromEmbedded(disableNotifications);
  }
  async l2NavFlow(exchangeTokenCookie, disableNotifications = false) {
    console.debug('initAuthentication.l2NavFlow');
    CookieUtils.removeCookie(this.TOKEN_EXCHANGE_COOKIE, {
      path: '/',
      domain: CookieUtils.getDomain()
    });
    await UserService.instance.initUserFromCookie(atob(exchangeTokenCookie), disableNotifications);
  }
  tokenInStorageFlow(useCookie, disableNotifications = false) {
    console.debug('initAuthentication.tokenInStorageFlow');
    UserService.instance.initUserFromLocalStorage(useCookie, disableNotifications);
    if (URLUtils.hasParameter(window.location.href, 'auth')) {
      window.location.href = URLUtils.removeURLParameter(window.location.href, 'auth');
    }
  }
  initScreenLayoutService(embeddedClient) {
    console.debug('initScreenLayoutService.start');
    if (embeddedClient) {
      ScreenUtils.instance.setCustomLayoutValue(true);
    }
    if (!embeddedClient) {
      ScreenUtils.instance.setCustomLayoutValue(false);
    }
    console.debug('initScreenLayoutService.end');
  }
  startRouter(options, mfeRoutePrefixSlash) {
    this.router = this.injector.get(Router);
    registerOnStart(this.router, this.translationPipe, options, mfeRoutePrefixSlash);
    registerOnSuccess(this.router, this.translationPipe, options, mfeRoutePrefixSlash);
    if (!options.disableRouterFunctionalityForLegacyApps) {
      registerOtherwise(this.router, options, mfeRoutePrefixSlash);
      registerOnUrlChange(this.router, options, mfeRoutePrefixSlash);
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function WebAppInitializerService_Factory(t) {
      return new (t || WebAppInitializerService)(i0.ɵɵinject(HttpClient), i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(TranslationPipe$1));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WebAppInitializerService,
      factory: WebAppInitializerService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WebAppInitializerService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: i1.HttpClient,
    decorators: [{
      type: Inject,
      args: [HttpClient]
    }]
  }, {
    type: ConfigurationService,
    decorators: [{
      type: Inject,
      args: [ConfigurationService]
    }]
  }, {
    type: i0.Injector
  }, {
    type: i2.TranslationPipe,
    decorators: [{
      type: Inject,
      args: [TranslationPipe$1]
    }]
  }], null);
})();
const isRootMatcher = prefix => {
  return url => {
    prefix = prefix.replace(/\/?$/, ''); // remove trailing slash, if present
    const fullUrl = url.map(u => u.path).join('/');
    if (fullUrl === prefix || fullUrl === prefix + '/') {
      return {
        consumed: url
      };
    }
    return null;
  };
};
// Copied from @angular-architects/module-federation-tools and fixed
const connectRouter = (router, useHash = false) => {
  if (!useHash) {
    router.navigateByUrl(`${location.pathname.substr(1)}${location.search}`);
    window.addEventListener('popstate', () => {
      router.navigateByUrl(`${location.pathname.substr(1)}${location.search}`);
    });
  } else {
    router.navigateByUrl(`${location.hash.substr(1)}${location.search}`);
    window.addEventListener('hashchange', () => {
      router.navigateByUrl(`${location.hash.substr(1)}${location.search}`);
    });
  }
};
class CXOneHybridHelper {
  static getAngularObjectFromInjector(angularJSInjector, objectName) {
    return angularJSInjector.get(objectName);
  }
  static getAngularObjectFromWindow() {
    return window.angular;
  }
  static listenForAngularEvent(angularJSInjector) {
    const angularJSSubscribe = CXOneHybridHelper.getAngularObjectFromInjector(angularJSInjector, 'SubscribeService');
    SubscribeService.instance.subscribeToEvent('UPDATE_TOKEN', data => {
      console.debug('%%received token from Angular');
      const user = CXOneHybridHelper.getAngularObjectFromInjector(angularJSInjector, 'User');
      user.token = data;
    });
    SubscribeService.instance.subscribeToEvent('BEFORE_MODULE_UNLOAD_NG2', data => {
      angularJSSubscribe.invokeSubscribeCallbacks('BEFORE_MODULE_UNLOAD', data, false);
    });
  }
  static sendEventToAngular(angularJSInjector) {
    const angularJSSubscribe = CXOneHybridHelper.getAngularObjectFromInjector(angularJSInjector, 'SubscribeService');
    angularJSSubscribe.subscribeToEvent('IDLE_TIMEOUT_UPDATED', data => {
      SubscribeService.instance.invokeSubscribeCallbacks('IDLE_TIMEOUT_UPDATED', data, false);
    });
    angularJSSubscribe.subscribeToEvent('REFRESH_FAVORITE_IN_PROJECTION', data => {
      SubscribeService.instance.invokeSubscribeCallbacks('REFRESH_FAVORITE_IN_PROJECTION', data, false);
    });
    angularJSSubscribe.subscribeToEvent('BEFORE_MODULE_UNLOAD', data => {
      SubscribeService.instance.invokeSubscribeCallbacks('BEFORE_MODULE_UNLOAD', data, false);
    });
    angularJSSubscribe.subscribeToEvent('SIDEBAR_COLLAPSE_STATE', data => {
      SubscribeService.instance.invokeSubscribeCallbacks('SIDEBAR_COLLAPSE_STATE', data, false);
    });
    angularJSSubscribe.subscribeToEvent('disableNav', data => {
      SubscribeService.instance.invokeSubscribeCallbacks('disableNav', data, false);
    });
  }
  static listenForBroadcasts() {
    const controllerElement = document.querySelector('body');
    if (controllerElement && CXOneHybridHelper.getAngularObjectFromWindow()) {
      const controllerScope = CXOneHybridHelper.getAngularObjectFromWindow().element(controllerElement).scope();
      controllerScope.$on('SIDEBAR-OPEN-CLOSE', (_event, data) => {
        SubscribeService.instance.invokeSubscribeCallbacks('SIDEBAR-OPEN-CLOSE', data, false);
      });
    }
  }
  static sendEventsBackAndForth(angularJSInjector) {
    CXOneHybridHelper.listenForBroadcasts();
    CXOneHybridHelper.listenForAngularEvent(angularJSInjector);
    CXOneHybridHelper.sendEventToAngular(angularJSInjector);
  }
}
class MfeOverlayContainerClass {
  constructor(classToAdd) {
    this.classToAdd = classToAdd;
  }
}
/** How to use
 *  In your app module, add one of the following lines to the providers array:
 *
 *    (with default class name, for child apps)
 *    { provide: OverlayContainer, useFactory: (platform: Platform) => new MfeOverlayContainer(document, platform) },
 *
 *    (with customized class name, for the container app)
 *    { provide: OverlayContainer, useFactory: (platform: Platform) => new MfeOverlayContainer(document, platform), new MfeOverlayContainerClass('cxone-mfe-container-app') },
 */
class MfeOverlayContainer extends OverlayContainer {
  constructor(_document, platform, overlayClass) {
    super(_document, platform);
    this.overlayClass = overlayClass;
  }
  _createContainer() {
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container');
    if (this.overlayClass) {
      container.classList.add(this.overlayClass.classToAdd);
    } else {
      container.classList.add('cxone-mfe-child-app');
    }
    document.querySelector('body').appendChild(container);
    this._containerElement = container;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MfeOverlayContainer_Factory(t) {
      return new (t || MfeOverlayContainer)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i1$2.Platform), i0.ɵɵinject(MfeOverlayContainerClass));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MfeOverlayContainer,
      factory: MfeOverlayContainer.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MfeOverlayContainer, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i1$2.Platform
  }, {
    type: MfeOverlayContainerClass
  }], null);
})();
class ClientPlatformWrapperService {
  getURLChangeService() {
    return URLChangeService.instance;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function ClientPlatformWrapperService_Factory(t) {
      return new (t || ClientPlatformWrapperService)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ClientPlatformWrapperService,
      factory: ClientPlatformWrapperService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClientPlatformWrapperService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], null, null);
})();
class CXOneConstants {
  static {
    this.CXONE_TOKEN_HEADER = 'CXONETokenNeeded';
  }
  static {
    this.USER_TOKEN_LS_NAME = 'wfo_saas.userToken';
  }
  static {
    this.PM_SELECTED_TEAMS = 'pm.selectedTeams';
  }
  static {
    this.PM_SELECTED_GROUPS = 'pm.selectedGroups';
  }
  static {
    this.PM_FROM_DATE = 'pm.fromDate';
  }
  static {
    this.PM_TO_DATE = 'pm.toDate';
  }
  static {
    this.PM_LAST_SELECTED_TEAMS = 'pm.lastSelectedGroup';
  }
  static {
    this.PM_LAST_FROM_DATE = 'pm.lastFromDate';
  }
  static {
    this.PM_LAST_TO_DATE = 'pm.lastToDate';
  }
  static {
    this.HTTP_HEADERS = {
      'retry-after': 'retry-after'
    };
  }
}
class CXOneHttpRequestInterceptor {
  constructor() {}
  intercept(request, next) {
    const newHeaders = {};
    const sendCXOneAuthToken = request.headers.get(CXOneConstants.CXONE_TOKEN_HEADER) === 'true';
    request.headers.keys().forEach(key => {
      if (key !== CXOneConstants.CXONE_TOKEN_HEADER && key !== 'Authorization') {
        newHeaders[key] = request.headers.get(key);
      }
    });
    if (sendCXOneAuthToken) {
      newHeaders.Authorization = `Bearer ${LocalStorageUtils.getItem(LocalStorageUtils.KEYS.userToken)}`;
    }
    newHeaders['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    newHeaders['Cache-Control'] = 'no-cache';
    request = request.clone({
      headers: new HttpHeaders(newHeaders)
    });
    return next.handle(request);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function CXOneHttpRequestInterceptor_Factory(t) {
      return new (t || CXOneHttpRequestInterceptor)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CXOneHttpRequestInterceptor,
      factory: CXOneHttpRequestInterceptor.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CXOneHttpRequestInterceptor, [{
    type: Injectable
  }], () => [], null);
})();
class CXOneHttpResponseInterceptor {
  intercept(req, next) {
    return next.handle(req).pipe(map(val => {
      if (val instanceof HttpResponse) {
        const body = val.body;
        this.convert(body);
      }
      return val;
    }));
  }
  convert(body) {
    if (body === null || body === undefined) {
      return body;
    }
    if (typeof body !== 'object') {
      return body;
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (typeof value === 'string') {
        if (DateUtils.isISO8601Date(value)) {
          body[key] = new Date(value);
        }
      } else if (typeof value === 'object') {
        this.convert(value);
      }
    }
  }
}

/*
 * This can be used with an Observale retryWHen operator.  For example:
 *
 * httpClient.get('http://myurl).pipe(
 *   retryWhen(HttpRetryStrategy({
 *       maxRetryAttempts: 3,
 *       scalingDuration: 1000,
 *        includedStatusCodes = [503],
 *        retryHeaderNeeded
 *   }));
 *
 * If you pass an empty object to HttpRetryStrategy then all requests which return a 503 will be retried 3 times
 * with an exponentional back off of 1000 (1 second)
 *
 * Options
 * maxRetryAttempts - The maximum number of retry attempts, defaults to 3
 * scalingDuration - Exponential back off (retryAttempt * scaling duration)
 * includedStatusCodes - Which http response codes will trigger a retry
 * retryHeaderNeeded - Used in conjunction with includedStatusCodes.  Requires the response to have this header.  The value
 *                     of the header will be used instead of scalingDuration to determine the exponential back off
 */
const HttpRetryStrategy = ({
  maxRetryAttempts = 3,
  scalingDuration = 1000,
  includedStatusCodes = [503],
  retryHeaderNeeded = null
} = {}) => attempts => {
  return attempts.pipe(mergeMap((error, i) => {
    const retryAttempt = i + 1;
    let retryHeaderValue = retryHeaderNeeded ? error.headers.get(retryHeaderNeeded) : null;
    const hasRetryStatusCode = includedStatusCodes.find(e => e === error.status);
    const shouldRetry = hasRetryStatusCode && (retryHeaderValue || retryHeaderNeeded === null);
    if (shouldRetry) {
      if (!retryHeaderValue) {
        retryHeaderValue = scalingDuration;
      } else if (isNaN(retryHeaderValue)) {
        retryHeaderValue = scalingDuration;
      }
    }
    if (retryAttempt > maxRetryAttempts || !shouldRetry) {
      return throwError(error);
    }
    return timer(retryAttempt * retryHeaderValue);
  }));
};

/*
 * How http requests are retried is documented in HttpRetryStrategy.ts
 */
class HttpUtils {
  static generatePrefix(options) {
    const hasOverridePrefixValue = options?.overridePrefixValue?.length;
    if (hasOverridePrefixValue !== undefined) {
      return options?.overridePrefixValue;
    }
    if (!ConfigurationService$1.instance.get(ConfigurationService$1.COMMON_KEYS.ApiFacadeOptOut)) {
      return ConfigurationService$1.instance.get('apiFacadeEndpoint');
    } else {
      return ConfigurationService$1.instance.get('apiServerBaseUrl');
    }
  }
  static buildUrl(url, params, prefix) {
    const queryParameters = {};
    if (prefix) {
      if (prefix.charAt(prefix.length - 1) !== '/') {
        prefix = prefix + '/';
      }
      if (url.charAt(0) === '/') {
        url = url.substring(1);
      }
      url = `${prefix}${url}`;
    }
    if (!params) {
      return url;
    }
    Object.keys(params).forEach(paramName => {
      if (url.includes(`:${paramName}`)) {
        url = url.replace(`:${paramName}`, params[paramName]);
      } else {
        queryParameters[paramName] = params[paramName];
      }
    });
    const queryString = Object.keys(queryParameters).map(key => key + '=' + queryParameters[key]).join('&');
    if (queryString) {
      url += url.includes('?') ? `&${queryString}` : `?${queryString}`;
    }
    return url;
  }
  constructor(http) {
    this.http = http;
    this.retryOptions = {
      maxRetryAttempts: 3,
      scalingDuration: 1000,
      includedStatusCodes: [503],
      retryHeaderNeeded: CXOneConstants.HTTP_HEADERS['retry-after']
    };
  }
  isHeaderKeyContentType(headerKey) {
    return headerKey.toLowerCase() === 'content-type';
  }
  isHeadeValueEmpty(headerValue) {
    if (Array.isArray(headerValue)) {
      return headerValue.length === 0;
    } else if (typeof headerValue === 'string' || headerValue instanceof String) {
      return headerValue === '';
    } else {
      return !headerValue;
    }
  }
  getOptions(options = {}, noTokenRequired) {
    let removeContentTypeHeader = false;
    const allOptions = {};
    const appContext = HttpUtils$1.getTraceabilityHeaderValue();
    let allHeaders = {
      'Content-Type': 'application/json',
      'Originating-Service-Identifier': appContext,
      [CXOneConstants.CXONE_TOKEN_HEADER]: noTokenRequired ? 'false' : 'true'
    };
    Object.keys(options).forEach(key => {
      if (key === 'headers') {
        if (options.headers instanceof HttpHeaders) {
          options.headers.keys().forEach(headerKey => {
            if (!this.isHeaderKeyContentType(headerKey) || this.isHeaderKeyContentType(headerKey) && !this.isHeadeValueEmpty(options.headers.get(headerKey))) {
              allHeaders[headerKey] = options.headers.get(headerKey);
            } else {
              removeContentTypeHeader = true;
            }
          });
        } else {
          allHeaders = {
            ...allHeaders,
            ...options.headers
          };
        }
        for (const allHeadersKey in allHeaders) {
          if (allHeaders.hasOwnProperty(allHeadersKey) && allHeadersKey.toLowerCase() === 'content-type' && allHeaders[allHeadersKey] === '') {
            delete allHeaders[allHeadersKey];
          }
        }
        if (removeContentTypeHeader) {
          delete allHeaders['Content-Type'];
        }
        allOptions.headers = allHeaders;
      } else {
        allOptions[key] = options[key];
      }
    });
    if (!options.headers) {
      allOptions.headers = allHeaders;
    }
    return allOptions;
  }
  internalGet(url, options, noTokenRequired, prefixURL) {
    url = HttpUtils.buildUrl(url, options && options.params ? options.params : null, prefixURL);
    const computedOptions = this.getOptions(options, noTokenRequired);
    delete computedOptions.params;
    return this.http.get(url, computedOptions).pipe(retryWhen(HttpRetryStrategy(this.retryOptions)));
  }
  /**
  * @deprecated Use {@link apiGet}  or  {@link staticGet} instead
  */
  get(url, options, noTokenRequired) {
    return this.internalGet(url, options, noTokenRequired);
  }
  apiGet(url, options, noTokenRequired) {
    const prefix = HttpUtils.generatePrefix(options);
    return this.internalGet(url, options, noTokenRequired, prefix);
  }
  staticGet(url, options, noTokenRequired) {
    return this.internalGet(url, options, noTokenRequired);
  }
  internalPost(url, body, options, noTokenRequired, prefixURL) {
    url = HttpUtils.buildUrl(url, options && options.params ? options.params : null, prefixURL);
    const computedOptions = this.getOptions(options, noTokenRequired);
    delete computedOptions.params;
    return this.http.post(url, body, computedOptions).pipe(retryWhen(HttpRetryStrategy(this.retryOptions)));
  }
  /**
  * @deprecated Use {@link apiPost}
  */
  post(url, body, options, noTokenRequired) {
    return this.internalPost(url, body, options, noTokenRequired);
  }
  apiPost(url, body, options, noTokenRequired) {
    const prefix = HttpUtils.generatePrefix(options);
    return this.internalPost(url, body, options, noTokenRequired, prefix);
  }
  internalPut(url, body, options, noTokenRequired, prefixURL) {
    url = HttpUtils.buildUrl(url, options && options.params ? options.params : null, prefixURL);
    const computedOptions = this.getOptions(options, noTokenRequired);
    delete computedOptions.params;
    return this.http.put(url, body, computedOptions).pipe(retryWhen(HttpRetryStrategy(this.retryOptions)));
  }
  /**
   * @deprecated Use {@link apiPut}
   */
  put(url, body, options, noTokenRequired) {
    return this.internalPut(url, body, options, noTokenRequired);
  }
  apiPut(url, body, options, noTokenRequired) {
    const prefix = HttpUtils.generatePrefix(options);
    return this.internalPut(url, body, options, noTokenRequired, prefix);
  }
  internalPatch(url, body, options, noTokenRequired, prefixURL) {
    url = HttpUtils.buildUrl(url, options && options.params ? options.params : null, prefixURL);
    const computedOptions = this.getOptions(options, noTokenRequired);
    delete computedOptions.params;
    return this.http.patch(url, body, computedOptions).pipe(retryWhen(HttpRetryStrategy(this.retryOptions)));
  }
  /**
   * @deprecated Use {@link apiPatch}
   */
  patch(url, body, options, noTokenRequired) {
    return this.internalPatch(url, body, options, noTokenRequired);
  }
  apiPatch(url, body, options, noTokenRequired) {
    const prefix = HttpUtils.generatePrefix(options);
    return this.internalPatch(url, body, options, noTokenRequired, prefix);
  }
  internalDelete(url, body, options, noTokenRequired, prefixURL) {
    const bodyObject = {
      body
    };
    options = {
      ...options,
      ...bodyObject
    };
    url = HttpUtils.buildUrl(url, options && options.params ? options.params : null, prefixURL);
    const computedOptions = this.getOptions(options, noTokenRequired);
    delete computedOptions.params;
    return this.http.delete(url, computedOptions).pipe(retryWhen(HttpRetryStrategy(this.retryOptions)));
  }
  /**
   * @deprecated Use {@link apiDelete}
   */
  delete(url, body, options, noTokenRequired) {
    return this.internalDelete(url, body, options, noTokenRequired);
  }
  apiDelete(url, body, options, noTokenRequired) {
    const prefix = HttpUtils.generatePrefix(options);
    return this.internalDelete(url, body, options, noTokenRequired, prefix);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function HttpUtils_Factory(t) {
      return new (t || HttpUtils)(i0.ɵɵinject(i1.HttpClient));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HttpUtils,
      factory: HttpUtils.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpUtils, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: i1.HttpClient
  }], null);
})();

/*
 * Public API Surface of cxone-core-services
 */

class PlanMonitoringService {
  constructor(httpUtils) {
    this.httpUtils = httpUtils;
  }
  getPlans() {
    return this.httpUtils.get('/qm-reporting/monitor/plans');
  }
  getPlanDetails(planId) {
    const params = new HttpParams().set('planUUID', planId);
    return this.httpUtils.get('/qm-reporting/monitor/plan/drilldown', params);
  }
  getHistoricalPlanDetails(planId, planOccurenceId) {
    const params = new HttpParams().set('planOccurrenceId', planOccurenceId).set('planUUID', planId);
    return this.httpUtils.get('/qm-reporting/monitor/plan/drilldown/v2', params);
  }
  consumptionTrendData(data) {
    if (data.length > 0) {
      this.consumptionTrendDataValue = data;
    } else {
      return this.consumptionTrendDataValue;
    }
  }
  consumptionTrendPrefilledData(data) {
    if (data.length > 0) {
      this.consumptionTrendPrefilledDataValue = data;
    } else {
      return this.consumptionTrendPrefilledDataValue;
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function PlanMonitoringService_Factory(t) {
      return new (t || PlanMonitoringService)(i0.ɵɵinject(HttpUtils));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PlanMonitoringService,
      factory: PlanMonitoringService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanMonitoringService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: HttpUtils
  }], null);
})();
class TeamsService {
  constructor(httpUtils) {
    this.httpUtils = httpUtils;
    this.teamSearchV3 = function (filter, fields, skip, top, operations, orderBy) {
      const body = {
        filter,
        fields,
        skip,
        top,
        operations,
        orderBy
      };
      return this.httpUtils.apiPost('/user-management/v3/teams/search', body);
    };
  }
  getTeams(filters, metrics) {
    const requestBody = {
      filter: filters,
      metrices: metrics
    };
    return this.httpUtils.apiPost('/user-management/v1/teams/search', requestBody);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TeamsService_Factory(t) {
      return new (t || TeamsService)(i0.ɵɵinject(HttpUtils));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TeamsService,
      factory: TeamsService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamsService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: HttpUtils
  }], null);
})();
class GroupService {
  constructor(httpUtils) {
    this.httpUtils = httpUtils;
  }
  getGroups() {
    return this.httpUtils.apiGet('/group').pipe(map(res => {
      if (!res.groups) {
        res.groups = [];
      }
      return res.groups;
    }), catchError(error => {
      console.error('Cannot get groups reason .', error);
      return throwError(error);
    }));
  }
  getGroupUsers(groupId) {
    const requestBody = {
      groupId
    };
    return this.httpUtils.apiPost('/group/users', requestBody).pipe(map(res => {
      if (!res.groupUsers) {
        res.groupUsers = [];
      }
      return res.groupUsers;
    }), catchError(error => {
      console.error('Cannot get group Users reason .', error);
      return throwError(error);
    }));
  }
  addGroup(group, userIds) {
    const groupObject = {
      id: '',
      name: '',
      usersIds: []
    };
    groupObject.name = group.name;
    groupObject.usersIds = [];
    if (userIds) {
      userIds.map(user => groupObject.usersIds.push(user));
    }
    return this.httpUtils.apiPost('/group', groupObject);
  }
  updateGroup(group, userIds) {
    const groupObject = {
      id: '',
      name: '',
      usersIds: []
    };
    groupObject.id = group.id;
    groupObject.name = group.name;
    groupObject.usersIds = [];
    if (userIds) {
      userIds.map(user => groupObject.usersIds.push(user));
    }
    return this.httpUtils.apiPut('/group', groupObject);
  }
  deleteGroups(groupsToDelete) {
    const requestGroupObject = {
      groupToDeleteIds: []
    };
    groupsToDelete.map(group => requestGroupObject.groupToDeleteIds.push(group.id));
    return this.httpUtils.apiPost('/group/delete', requestGroupObject);
  }
  checkGroupExistenceByName(groupName) {
    const requestObj = {
      name: ''
    };
    requestObj.name = groupName;
    return this.httpUtils.apiPost('/group/exists', requestObj);
  }
  getGroupLabelPairs() {
    let groupList;
    return this.getGroups().pipe(map(groups => {
      groupList = groups.map(group => {
        return {
          id: group.id,
          label: group.name
        };
      });
      return groupList;
    }), catchError(err => {
      console.error('Unable to get groups. reason', err);
      return throwError(err);
    }));
  }
  /** @nocollapse */
  static {
    this.ɵfac = function GroupService_Factory(t) {
      return new (t || GroupService)(i0.ɵɵinject(HttpUtils));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GroupService,
      factory: GroupService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: HttpUtils
  }], null);
})();
class PerformanceMonitoringService {
  constructor(httpUtils, teamsService, groupsService) {
    this.httpUtils = httpUtils;
    this.teamsService = teamsService;
    this.groupsService = groupsService;
  }
  getPerformanceDataForTeamsAndGroups(teamIds, groupIds, fromDate, toDate) {
    const requestBody = {
      teamIds,
      groupIds,
      toDate,
      fromDate
    };
    return this.httpUtils.post('/qm-reporting/monitor/v1/performance', requestBody);
  }
  updateToDateData(filterData) {
    const toDateDetails = this.getToDateDataByFromDate(filterData.fromDate, filterData.toDate);
    filterData.minToDate = toDateDetails.minToDate;
    filterData.maxToDate = toDateDetails.maxToDate;
    filterData.toDate = toDateDetails.toDate;
  }
  getValidData(data, source) {
    let validData = [];
    validData = data.filter(item => source.indexOf(item.id) !== -1);
    return validData;
  }
  getInitialFilterDataWithTeamsAndGroups() {
    const filterDataObject = {
      maxFromDate: '',
      fromDate: '',
      toDate: '',
      groups: '',
      teams: '',
      selectedGroups: '',
      selectedTeams: '',
      selectedGroup: '',
      minToDate: '',
      maxToDate: ''
    };
    // set default values
    filterDataObject.groups = [];
    filterDataObject.teams = [];
    filterDataObject.selectedGroups = [];
    filterDataObject.selectedTeams = [];
    const today = new Date();
    filterDataObject.maxFromDate = today;
    filterDataObject.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    filterDataObject.toDate = new Date(today.getFullYear(), today.getMonth(), 0);
    return forkJoin([this.teamsService.getTeams(), this.groupsService.getGroups()]).pipe(map(result => {
      filterDataObject.teams = result[0].teams;
      filterDataObject.groups = result[1];
      const savedFilterData = this.getTeamsAndGroupsFiltersFromLocalStorage();
      if (savedFilterData && savedFilterData.fromDate) {
        filterDataObject.selectedTeams = this.getValidData(savedFilterData.selectedTeams, filterDataObject.teams.map(team => team.id));
        filterDataObject.selectedGroups = this.getValidData(savedFilterData.selectedGroups, filterDataObject.groups.map(group => group.id));
        filterDataObject.fromDate = new Date(savedFilterData.fromDate);
        filterDataObject.toDate = new Date(savedFilterData.toDate);
      }
      this.updateToDateData(filterDataObject);
      return filterDataObject;
    }), catchError(err => {
      console.error('performanceMonitoringService: failed to fetch teams and groups data, reason: ' + err.details);
      return throwError(err);
    }));
  }
  getToDateDataByFromDate(fromDate, toDate) {
    if (!fromDate) {
      // toDate data can't be calculated if fromDate is not available
      return null;
    }
    // set default values
    const toDateDataDetails = {
      toDate,
      minToDate: fromDate,
      maxToDate: moment(fromDate).add(365, 'days').toDate()
    };
    const today = new Date();
    // set toDate to the minimal toDate in case it is earlier
    if (toDateDataDetails.toDate && moment(toDateDataDetails.toDate).isBefore(toDateDataDetails.minToDate, 'days')) {
      toDateDataDetails.toDate = toDateDataDetails.minToDate;
    }
    // set max toDate value to today in case it is later
    if (moment(toDateDataDetails.maxToDate).isAfter(today, 'days')) {
      toDateDataDetails.maxToDate = today;
    }
    // set toDate to the maximal toDate in case it is later
    if (toDateDataDetails.toDate && moment(toDateDataDetails.toDate).isAfter(toDateDataDetails.maxToDate, 'days')) {
      toDateDataDetails.toDate = toDateDataDetails.maxToDate;
    }
    return toDateDataDetails;
  }
  getPerformanceDetailsForAgentWithFilters(userId, fromDate, toDate, groupIds, teamIds) {
    const performanceDetailsParams = {
      fromDate,
      toDate,
      groupIds,
      teamIds
    };
    return this.httpUtils.post('/qm-reporting/monitor/v1/performance/' + userId, performanceDetailsParams);
  }
  setTeamsAndGroupsFiltersToLocalStorage(selectedTeams, selectedGroups, fromDate, toDate) {
    localStorage.setItem(CXOneConstants.PM_SELECTED_TEAMS, JSON.stringify(selectedTeams));
    localStorage.setItem(CXOneConstants.PM_SELECTED_GROUPS, JSON.stringify(selectedGroups));
    localStorage.setItem(CXOneConstants.PM_FROM_DATE, btoa(fromDate));
    localStorage.setItem(CXOneConstants.PM_TO_DATE, btoa(toDate));
  }
  getTeamsAndGroupsFiltersFromLocalStorage() {
    try {
      return {
        selectedTeams: localStorage.getItem(CXOneConstants.PM_SELECTED_TEAMS) ? JSON.parse(localStorage.getItem(CXOneConstants.PM_SELECTED_TEAMS)) : [],
        selectedGroups: localStorage.getItem(CXOneConstants.PM_SELECTED_GROUPS) ? JSON.parse(localStorage.getItem(CXOneConstants.PM_SELECTED_GROUPS)) : [],
        fromDate: localStorage.getItem(CXOneConstants.PM_FROM_DATE) ? new Date(atob(localStorage.getItem(CXOneConstants.PM_FROM_DATE))) : null,
        toDate: localStorage.getItem(CXOneConstants.PM_TO_DATE) ? new Date(atob(localStorage.getItem(CXOneConstants.PM_TO_DATE))) : null
      };
    } catch (error) {
      return {
        selectedTeams: localStorage.getItem(CXOneConstants.PM_SELECTED_TEAMS) ? JSON.parse(atob(localStorage.getItem(CXOneConstants.PM_SELECTED_TEAMS))) : [],
        selectedGroups: localStorage.getItem(CXOneConstants.PM_SELECTED_GROUPS) ? JSON.parse(atob(localStorage.getItem(CXOneConstants.PM_SELECTED_GROUPS))) : [],
        fromDate: localStorage.getItem(CXOneConstants.PM_FROM_DATE) ? new Date(atob(localStorage.getItem(CXOneConstants.PM_FROM_DATE))) : null,
        toDate: localStorage.getItem(CXOneConstants.PM_TO_DATE) ? new Date(atob(localStorage.getItem(CXOneConstants.PM_TO_DATE))) : null
      };
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function PerformanceMonitoringService_Factory(t) {
      return new (t || PerformanceMonitoringService)(i0.ɵɵinject(HttpUtils), i0.ɵɵinject(TeamsService), i0.ɵɵinject(GroupService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PerformanceMonitoringService,
      factory: PerformanceMonitoringService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PerformanceMonitoringService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: HttpUtils
  }, {
    type: TeamsService
  }, {
    type: GroupService
  }], null);
})();

/*
 * Public API Surface of cxone-core-services
 */

const permission = (permissionString, messageTranslationKey) => {
  return (target, propertyKey, descriptor) => {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
      if (PermissionService.instance.allowAccess(permissionString)) {
        originalMethod.apply(this, args);
      } else if (messageTranslationKey) {
        this.toastrManager.showToaster('error', this.translate.transform(messageTranslationKey));
      } else {
        this.toastrManager.showToaster('error', this.translate.transform('generalErrorMessages.missingPermissionError'));
      }
    };
    return descriptor;
  };
};
const requiredKeys = ['translationKey', 'appContext', 'apiServerBaseUrl'];
const WidgetInitializerFactory = (locationInitializer, config, initService, options) => {
  const allOptions = {
    ...{
      cxoneSuiteDefaults: true
    },
    ...options
  };
  return () => {
    return new Promise((resolve, reject) => {
      // Populate configuration data
      config.initFromHttpRequest().subscribe(configData => {
        const hasAllKeys = ObjectUtils.hasAllKeys(requiredKeys, configData);
        if (hasAllKeys) {
          try {
            // Load localization strings
            locationInitializer.load().then(() => {
              if (initService) {
                initService.init(allOptions).then(initResult => {
                  if (!initResult) {
                    reject();
                  } else {
                    resolve();
                  }
                });
              } else {
                resolve();
              }
            });
          } catch {
            reject();
          }
        } else {
          console.error('configuration.json is missing a required key', requiredKeys);
          reject();
        }
      });
    });
  };
};
class InitializerService {
  static {
    this.WebAppOptionsDefault = {
      cxoneSuiteDefaults: true
    };
  }
  constructor(configService, translationPipe) {
    this.loggingInfoStyles = '';
    this.configService = configService;
    this.translationPipe = translationPipe;
  }
  async init(options) {
    console.debug('InitializerService.init options', options.cxoneSuiteDefaults, options.customInitFn);
    await DateTimeFormattingService.instance.getDateTimeFormatByBrowserLocale().catch(reason => {
      console.error('There was an issue but we are continuing.  Your mileage may vary', reason);
    });
    if (options.customInitFn) {
      await options.customInitFn().catch(reason => {
        console.error('There was an issue with your custom function.  Your mileage may vary', reason);
      });
    }
    return true;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function InitializerService_Factory(t) {
      return new (t || InitializerService)(i0.ɵɵinject(ConfigurationService), i0.ɵɵinject(TranslationPipe$1));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InitializerService,
      factory: InitializerService.ɵfac,
      providedIn: CoreServicesModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InitializerService, [{
    type: Injectable,
    args: [{
      providedIn: CoreServicesModule
    }]
  }], () => [{
    type: ConfigurationService,
    decorators: [{
      type: Inject,
      args: [ConfigurationService]
    }]
  }, {
    type: i2.TranslationPipe,
    decorators: [{
      type: Inject,
      args: [TranslationPipe$1]
    }]
  }], null);
})();

/*
 * Public API Surface of cxone-core-services
 */

class TranslationPipe {
  constructor(i18nextPipe) {
    this.i18nextPipe = i18nextPipe;
  }
  transform(key, options) {
    return this.i18nextPipe.transform(key, options);
  }
  transformErrorObject(errorObject, prefix = '') {
    const errorKey = `${prefix}.errors.${errorObject.code}.message`;
    let translateResults = this.transform(errorKey);
    if (translateResults.includes(errorObject.code)) {
      translateResults = this.transform('cxone-components.errors.general');
    }
    return translateResults;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TranslationPipe_Factory(t) {
      return new (t || TranslationPipe)(i0.ɵɵdirectiveInject(i1$3.I18NextPipe, 16));
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "translate",
      type: TranslationPipe,
      pure: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationPipe, [{
    type: Pipe,
    args: [{
      name: 'translate',
      pure: false
    }]
  }], () => [{
    type: i1$3.I18NextPipe
  }], null);
})();
class TranslateDirective {
  constructor(element, translationPipe) {
    this.element = element;
    this.translationPipe = translationPipe;
    if (this.translate) {
      this.translateString();
    }
  }
  ngOnChanges() {
    this.translateString();
  }
  translateString() {
    this.element.nativeElement.innerText = this.translationPipe.transform(this.translate);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TranslateDirective_Factory(t) {
      return new (t || TranslateDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TranslateDirective,
      selectors: [["", "translate", ""]],
      inputs: {
        translate: "translate"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslateDirective, [{
    type: Directive,
    args: [{
      // tslint:disable-next-line: directive-selector
      selector: '[translate]'
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: TranslationPipe
  }], {
    translate: [{
      type: Input
    }]
  });
})();
class TranslationModule {
  /** @nocollapse */static {
    this.ɵfac = function TranslationModule_Factory(t) {
      return new (t || TranslationModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TranslationModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [TranslationPipe],
      imports: [CommonModule, I18NextModule.forRoot()]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TranslationModule, [{
    type: NgModule,
    args: [{
      declarations: [TranslationPipe, TranslateDirective],
      providers: [TranslationPipe],
      imports: [CommonModule, I18NextModule.forRoot()],
      exports: [TranslationPipe, TranslateDirective]
    }]
  }], null, null);
})();

/*
 * Public API Surface of cxone-core-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APP_CONFIG, AppInitializerFactory, CXOneConstants, CXOneHttpRequestInterceptor, CXOneHttpResponseInterceptor, CXOneHybridHelper, ClientPlatformWrapperService, ConfigurationService, CoreServicesModule, DynamicLocaleId, GroupService, HttpRetryStrategy, HttpUtils, InitializerService, LocalizationInitializer, LocalizationInitializerFactory, MfeOverlayContainer, MfeOverlayContainerClass, MfeUnsavedChangesGuard, PasswordExpiringService, PerformanceMonitoringService, PlanMonitoringService, TeamsService, TranslateDirective, TranslationModule, TranslationPipe, WebAppInitializerService, WebAppInitializerServiceOptions, WidgetInitializerFactory, connectRouter, isRootMatcher, permission };
